<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<ng-container [formGroup]="shipment.shipmentForm">
   <mat-expansion-panel id="references" class="bordered references" formArrayName="references" [class.invalid]="(shipment.highlightInvalid$ | async) && references.invalid">
      <mat-expansion-panel-header>
         <mat-panel-title id="referencePanelTitle">Reference Details</mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngIf="[ 'party', 'type', 'data', 'actions' ] as columns">
         <mat-table #reference_table *ngIf="references.controls.length" [dataSource]="references.controls" class="rotate-cdk-table" class="common-mb1em">

            <ng-container matColumnDef="party">
               <mat-header-cell *matHeaderCellDef>{{config?.items?.party?.label ?? 'Party'}}</mat-header-cell>
               <mat-cell *matCellDef="let row; index as i" [formGroupName]="i">
                  <div class="cell">
                     <mat-label>{{config?.at?.[i]?.items?.party?.label ?? config?.items?.party?.label ?? 'Party'}}</mat-label>
                     <mat-form-field>
                        <mat-select id="referencePartySelect" #refparty formControlName="party" [required]="config?.at?.[i]?.items?.party?.required || config?.items?.party?.required || references.at( i ).errors?.allOf.includes(config?.allOf?.party?.label)">
                           <mat-option id="referencePartyOption">None</mat-option>
                           <mat-option id="referencePartyOption" *ngFor="let party of enums.refParties() | async" [value]="party">{{party | spacers | titlecase}}</mat-option>
                        </mat-select>
                        <mat-error libInputErrors [control]="references.at(i).get('party')"></mat-error>
                     </mat-form-field>
                  </div>
               </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
               <mat-header-cell *matHeaderCellDef>{{config?.items?.type?.label ?? 'Type'}}</mat-header-cell>
               <mat-cell *matCellDef="let row; index as i;" [formGroupName]="i">
                  <div class="cell">
                     <mat-label>{{config?.at?.[i]?.items?.type?.label ?? config?.items?.type?.label ?? 'Type'}}</mat-label>
                     <mat-form-field *ngIf="enums.reftypes( portal.current ) | async as reftypes; else spinner">
                        <mat-select id="referenceTypeSelect" #reftype formControlName="type" [required]="config?.at?.[i]?.items?.party?.required || config?.items?.party?.required || references.at( i ).errors?.allOf.includes(config?.allOf?.type?.label)">
                           <mat-option id="referenceTypeOption">None</mat-option>
                           <mat-option id="referenceTypeOption" *ngFor="let type of reftypes" [value]="type">{{type | spacers | uppercase}}</mat-option>
                        </mat-select>
                        <mat-error id="referenceTypeError" libInputErrors [control]="references.at(i).get('type')"></mat-error>
                     </mat-form-field>
                  </div>
               </mat-cell>
            </ng-container>

            <ng-container matColumnDef="data">
               <mat-header-cell *matHeaderCellDef>{{config?.items?.data?.label ?? 'Reference Number'}}</mat-header-cell>
               <mat-cell *matCellDef="let row; index as i" [formGroupName]="i">
                  <div class="cell" *ngIf="references.at( i ).get( 'data' ) as data">
                     <mat-label id="referenceNumberlabel">{{ config?.at?.[i]?.items?.data?.label ?? config?.items?.data?.label ?? 'Reference Number'}}</mat-label>
                     <mat-form-field>
                        <input id="referenceNumberInput" matInput #refnumber formControlName="data" [required]="config?.at?.[i]?.items?.data?.required || config?.items?.data?.required || references.at( i ).errors?.allOf.includes(config?.allOf?.data?.label)" [maxlength]="config?.items?.data?.maxLength" />
                        <mat-error id="referenceNumberError" libInputErrors [control]="references.at(i).get('data')"></mat-error>
                        <mat-hint id="referenceNumberHint" align="end"
                           *ngIf="data.enabled && document.activeElement === refnumber && data?.value?.length as l">
                           {{l || 0}} / {{config?.items?.data?.maxLength}}
                        </mat-hint>
                     </mat-form-field>
                  </div>
               </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
               <mat-header-cell *matHeaderCellDef class="common-fg05"></mat-header-cell>
               <mat-cell *matCellDef="let row; index as i; last as last" class="common-fg05">
                  <div class="cell">
                     <button id="removeReferenceButton" mat-icon-button *ngIf="!references.at(i).disabled && i >= (config?.minLength ?? 0)" (click)="removeRef(i)">
                        <mat-icon id="removeReferenceIcon" matTooltip="Remove">clear</mat-icon>
                     </button>
                  </div>
               </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; index as i; columns: columns"></mat-row>
         </mat-table>
      </ng-container>

      <div>
         <button id="addReferenceButton" mat-raised-button color="primary" (click)="addRef()">
            <mat-icon id="addReferenceIcon">add</mat-icon> ADD REFERENCE
         </button>
      </div>

      <ng-container *ngIf="shipment.highlightInvalid$ | async">
         <br/>
         <mat-error id="referenceError" *ngIf="references.errors" libInputErrors [control]="references"></mat-error>

         <ng-container *ngFor="let control of references.controls; index as index">
            <mat-error id="referenceNumberError" libInputErrors *ngIf="references.at( index ).errors" [control]="references.at( index )" suffix=" on Reference {{index + 1}}"></mat-error>
         </ng-container>
      </ng-container>
   </mat-expansion-panel>
</ng-container>
